import { LoadingModal } from '@/components/LoadingModal';
import { useTranslation } from '@/i18n';
import { FC, memo, useMemo } from 'react';
import classnames from 'classnames/bind';
import styles from './ProcessOcrInferenceLoading.module.scss';
const cx = classnames.bind(styles);
import { IconAILoading } from '@/components/Icons/IconAILoading';
type ProcessOcrInferenceLoadingProps = {
  isLoading: boolean;
  isNewFileUpload: boolean;
  aiProgressType?: string | null;
};

export const ProcessOcrInferenceLoading: FC<ProcessOcrInferenceLoadingProps> =
  memo(({ isLoading, isNewFileUpload, aiProgressType }) => {
    const { t } = useTranslation();
    const loadingText = useMemo(() => {
      if (aiProgressType === 'ai_suggest') {
        return (
          <div className={cx('ai-suggest-loading-container')}>
            <div>{t('process_ocr_inference_loading_ai_suggest_title')}</div>
            <div>{t('process_ocr_inference_loading_ai_suggest')}</div>
          </div>
        );
      } else {
        return isNewFileUpload
          ? t('process_ocr_inference_loading_new_file')
          : t('process_ocr_inference_loading_received_invoice');
      }
    }, [aiProgressType, isNewFileUpload, t]);

    return isLoading ? (
      <LoadingModal
        icon={
          aiProgressType === 'ai_suggest' ? (
            <IconAILoading size={100} />
          ) : undefined
        }
        open={isLoading}
        onClose={() => {}}
        text={loadingText}
        className={cx(
          aiProgressType === 'ai_suggest' && 'ai-suggest-loading-modal'
        )}
      />
    ) : null;
  });
ProcessOcrInferenceLoading.displayName = 'ProcessOcrInferenceLoading';
